import { Injectable } from '@angular/core';
import { AbstractEntityService } from '@app/shared/abstract/abstract-entity.service';
import { HttpClient } from '@angular/common/http';
import { ProductVariantModel } from './product-variant.model';

@Injectable({
  providedIn: 'root',
})
export class ProductVariantService extends AbstractEntityService<ProductVariantModel> {
  constructor(http: HttpClient) {
    super('/api/product-variants', http);
  }

  getUsage(variantId: number) {
    return this.http.get<{ events: Array<{ id: number; name: string; reference?: string | null; date: string | null }>; event_count: number }>(
      `${this.apiUrl}${this.basePath}/${variantId}/usage`,
    );
  }
}
